var map = {
	"./1_incoming.mp3": "a735",
	"./1_outgoing.mp3": "f58f",
	"./1_ring_in.mp3": "2dce",
	"./2_incoming.mp3": "d180",
	"./2_outgoing.mp3": "116c",
	"./2_ring_in.mp3": "b715",
	"./3_incoming.mp3": "4f19",
	"./3_outgoing.mp3": "c81f",
	"./3_ring_in.mp3": "3c2c",
	"./warten.mp3": "d41c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac03";